import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import { ToxnotComponentProperties } from '../core/BaseApplicationComponents/ToxnotComponent';
import { ToxnotSignInRequiredComponent } from '../core/BaseApplicationComponents/ToxnotSignInRequiredComponent';

import './styles.css';

interface StartOrientationState {
    
}

interface TourData {
    url: string;
    localizedName: string;
    localizedDescription: string;
}

// ===============================================================================

class StartOrientation extends ToxnotSignInRequiredComponent<ToxnotComponentProperties, StartOrientationState> {
    private readonly _tours: TourData[];

    public constructor(props: ToxnotComponentProperties) {
        super(props);

        this._tours = [
            {
                url: "/Start?product_tour_id=330158",
                localizedName: this.localizeString("Basic Navigation"),
                localizedDescription: this.localizeString("Learn the basics of navigating 3E Exchange's most used features.")
            },
            {
                url: "/Data/Library?category=Products&product_tour_id=332126",
                localizedName: this.localizeString("Product and Material Libary"),
                localizedDescription: this.localizeString("Learn how to find and manage your Product and Materials in their respective Libraries.")
            },
            {
                url: "/Data/Library?category=Materials&product_tour_id=332641",
                localizedName: this.localizeString("Product and Material Details"),
                localizedDescription: this.localizeString("Learn about all the data that may be associated with your Products and Materials.")
            },
            {
                url: "/Exchange?product_tour_id=332797",
                localizedName: this.localizeString("The Passport Library"),
                localizedDescription: this.localizeString("Learn about the Passport Library and how it benefits both Suppliers and Manufacturers.")
            },
            {
                url: "/Suppliers/Suppliers?product_tour_id=332799",
                localizedName: this.localizeString("Suppliers and Surveys"),
                localizedDescription: this.localizeString("Learn how to represent your Suppliers and how to send them Surveys.")
            },
            {
                url: "/Data/Library?product_tour_id=332804",
                localizedName: this.localizeString("Task-Oriented Workflows"),
                localizedDescription: this.localizeString("Learn what Task-Oriented Workflows are and how they help you accomplish your goals.")
            }
        ];
    }

    // ===============================================================================

    protected override getDisallowedRoles() {
        return [];
    }

    // ===============================================================================

    protected renderConcreteComponent(): JSX.Element {
        let keyIndex = 0;
        return (
            <div id="start-orientation-content" className="start-content">
                <div className="full-content">
                    <div className="start-subcontent-heading">
                        {this.localizeString("Take a Tour of 3E Exchange")}
                    </div>
                    <p className="start-subcontent-content-container">
                        {this.localizeString("Choose a tour below to get started.")}
                    </p>
                    <div className="start-subcontent-content-container">
                        <div className="selectors-container">
                            {this._tours.map(tour => (
                                <div key={keyIndex++} className="selector-div" onClick={e => location.href = tour.url}>
                                    <div className="title">{tour.localizedName}</div>
                                    <div className="description">{tour.localizedDescription}</div>
                                    <p className="description">
                                        <button type="button" className="btn btn-toxnot-complement">{this.localizeString("Start Tour")} <span className="glyphicon glyphicon-chevron-right"></span></button>
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state: ApplicationState) => ({ appServices: state.appServices })
)(StartOrientation as any);